import { makeStyles } from '@mui/styles';

export const useInviteMemberModalStyles = makeStyles(() => ({
  AccessLevelRadioGroup: { padding: '8px' },
  Radio: {
    marginTop: '-8px',
    '&.Mui-checked': {
      color: 'primary'
    }
  },
  RadioContainer: {
    alignItems: 'flex-start'
  }
}));
